import { arrayOf, string } from 'prop-types'

import InputTextWithFloatingLabel from 'views/components/molecules/InputTextWithFloatingLabel'

import './InputSuggest.scss'

const renderOptions = options =>
  options.map(option => (
    <option key={option} value={option}>
      {option.text}
    </option>
  ))

const InputSuggest = props => {
  const { id, options, children, name, ...rest } = props

  return (
    <>
      <div className="m-InputSuggest">
        <InputTextWithFloatingLabel
          inputType="text"
          list={id}
          name={name}
          {...rest}
        >
          {children}
        </InputTextWithFloatingLabel>
      </div>
      <datalist id={id}>{options && renderOptions(options)}</datalist>
    </>
  )
}

InputSuggest.propTypes = {
  options: arrayOf(string),
  ...InputTextWithFloatingLabel.propTypes,
}

InputSuggest.defaultProps = {
  options: [],
  ...InputTextWithFloatingLabel.defaultProps,
}

export default InputSuggest
